import { render, staticRenderFns } from "./TipsNotification.vue?vue&type=template&id=fb369642&"
import script from "./TipsNotification.vue?vue&type=script&lang=js&"
export * from "./TipsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports